import Alert from 'components/alert/Alert';
import strings from '../../../../../../strings/strings.json';
import React from 'react';
import { BuildCourseContext } from 'contextProviders/BuildCourseContext';
import useDeleteRequest from 'hooks/useDeleteRequest';
import { logError } from 'lib/debug-helpers';
import { publish } from 'lib/events';
import { Course } from 'models/Course';

type DeleteTaskProps = {
    taskId: string;
    moduleId: string;
    returnToCourseStructure: () => void;
    setAlertOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function DeleteActivityAlert({ taskId, returnToCourseStructure, setAlertOpen }: DeleteTaskProps) {
    const context = React.useContext(BuildCourseContext);
    const { setCourseState, editMode } = React.useContext(BuildCourseContext);

    const { deleteData, deleteInProgress } = useDeleteRequest(`activities/${taskId}`);

    async function onDelete() {
        if (editMode) {
            setCourseState((prev) => {
                const copy = structuredClone(prev) as Course;
                for (const module of copy.modules) {
                    const index = module.activities.findIndex((a) => a.id === taskId);
                    if (index !== -1) {
                        module.activities.splice(index, 1);
                        break;
                    }
                }

                return copy;
            });

            setAlertOpen(false);
            returnToCourseStructure();
            return;
        }

        const response = await deleteData();

        if (response.errors) {
            logError(response.errors);
            return;
        }

        publish('ACTIVITY_DELETED', { id: taskId });

        await context.refetchCourse();
        returnToCourseStructure();
        setAlertOpen(false);
    }
    return (
        <Alert
            buttonText={strings.courseContentPage.alertButton}
            ariaButtonText={strings.courseContentPage.alertButtonAria}
            alertText={strings.courseContentPage.alertText}
            closeAlert={() => setAlertOpen(false)}
            onSubmit={onDelete}
            submitting={deleteInProgress}
        />
    );
}
